import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { SiteProvider } from "@/context/SiteContext";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import Services from "@/pages/Services";
import Creatives from "@/pages/Creatives";
import CreativesSubpage from "@/pages/CreativesSubpage";
import AboutUs from "@/pages/AboutUs";
import Blogs from "@/pages/Blogs";
import BlogDetail from "@/pages/BlogDetail";
import Contact from "@/pages/Contact";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import { isAuthed } from "@/lib/api";

const RequireAuth = ({ children }) => (isAuthed() ? children : <Navigate to="/admin/login" replace />);

function App() {
  return (
    <SiteProvider>
      <BrowserRouter>
        <Toaster position="top-center" richColors />
        <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={<Home />} />
            <Route path="/services" element={<Services />} />
            <Route path="/creatives" element={<Creatives />} />
            <Route path="/creatives/:category" element={<CreativesSubpage />} />
            <Route path="/about" element={<AboutUs />} />
            <Route path="/blogs" element={<Blogs />} />
            <Route path="/blogs/:slug" element={<BlogDetail />} />
            <Route path="/contact" element={<Contact />} />
          </Route>
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<RequireAuth><AdminDashboard /></RequireAuth>} />
          <Route path="*" element={<Navigate to="/" />} />
        </Routes>
      </BrowserRouter>
    </SiteProvider>
  );
}

export default App;
